import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { useTranslation } from 'react-i18next';

const TeachingStaff = () => {
  const { t } = useTranslation();
  return <PageTemplate title={t('teaching_staff.title')} />;
};

export default TeachingStaff; 